export const TemplateDownload = () => {
  console.log();
  return (
    <div>テンプレートダウンロード</div>
  );
};
